module.exports = __webpack_public_path__ + "e04556b2e910aba917a411703529b9e3.fbx";